import { Button, FlexBox, SPACING, Typography } from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"
import { create } from "zustand"

import { useAddEditQuestStore } from "./useAddEditQuestStore"
import { CloseButton } from "../../../components/closeButton/CloseButton"
import SlideUpModal from "../../../components/slideUpModal/SlideUpModal"
import { useEditQuestMutation } from "../../../networking/quests/mutations"

interface ConfirmUngroupModalStoreProps {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

export const useConfirmUngroupModalStore =
  create<ConfirmUngroupModalStoreProps>()((set) => ({
    isOpen: false,
    onOpen: () => set({ isOpen: true }),
    onClose: () => {
      set({ isOpen: false })
      useAddEditQuestStore.getState().setIsGrouped(true)
    },
  }))

export const ConfirmUngroupModal = () => {
  const { isOpen, onClose } = useConfirmUngroupModalStore()
  const editQuestMutation = useEditQuestMutation()
  const { t } = useTranslation()

  return (
    <SlideUpModal
      isOpen={isOpen}
      onClose={onClose}
      size="fit-content"
      backgroundType="overlay"
      zIndex={1000}
    >
      <CloseButton onClick={onClose} />
      <FlexBox
        direction="column"
        gap={SPACING.space4}
        wrap={false}
        style={{
          padding: `${SPACING.space8} ${SPACING.space4} ${SPACING.space14} ${SPACING.space4}`,
        }}
        fullWidth
      >
        <Typography variant="bodyBold">
          {t("QUEST_UNGROUP_CONFIRM_TITLE")}
        </Typography>
        <Typography variant="bodySmall">
          {t("QUEST_UNGROUP_CONFIRM_HELP")}
        </Typography>
        <FlexBox
          direction="row"
          align="center"
          justify="space-between"
          gap={SPACING.space2}
          fullWidth
          wrap={false}
        >
          <Button
            buttonType="secondary"
            onClick={onClose}
            text={t("QUEST_BACK")}
            fullWidth
            style={{ borderRadius: SPACING.space2 }}
          />
          <Button
            buttonType="primary"
            onClick={async () => {
              await editQuestMutation.mutateAsync()
              onClose()
            }}
            text={t("QUEST_UNGROUP_SAVE")}
            isLoading={editQuestMutation.isLoading}
            fullWidth
            style={{ borderRadius: SPACING.space2 }}
          />
        </FlexBox>
      </FlexBox>
    </SlideUpModal>
  )
}
